export const SITE_NAME = 'Fast Fares';
export const SITE_DOMAIN = 'fastfares.info';
export const SITE_URL = 'https://fastfares.info/';
export const SITE_TAGLINE = 'Hotels, Cars, Packages & Cruises';

export const COMPANY_NAME = 'Nodex Global LLC';
export const COMPANY_EMAIL = 'info@nodexgloballlc.com';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';

export const AFFILIATE_DISCLOSURE =
  'Nodex Global LLC is an independent travel advisory company affiliated with Fora Travel.';

export const FOOTER_DISCLAIMER = [
  `${COMPANY_NAME} is an independent travel advisory company affiliated with Fora Travel. We provide travel planning, booking assistance, and concierge-style travel services for hotels, vacation packages, cruises, car rentals, and other travel experiences.`,
  'We serve as an intermediary between customers and travel suppliers. All reservations are subject to supplier availability, fare rules, cancellation policies, and applicable terms and conditions.',
  'Our customer support team is available seven days a week for booking assistance and post-booking support.',
];
